import React from 'react'

export const PrivacyNotice = ({name, className}) => {
  return (
    <span name={name} className={className}>
      เมื่อคลิกที่ "ส่งแบบฟอร์ม" ทางบริษัทจะหมายความว่าคุณยินยอมให้เราส่งข้อมูลที่คำขอดังกล่าวตาม&nbsp;
      <a href='/policy' target='_blank' rel='noopener noreferrer'>
        นโยบายความเป็นส่วนตัว
      </a>
      &nbsp;ของเรา.
    </span>
  )
}

export default PrivacyNotice
